import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IBulkEmailAffiliate,
  IBulkEmailAffiliatesBasePayload,
  IBulkEmailAffiliatesResponse,
} from '../types';
import {
  BULK_EMAILS_AFFILIATES_LIST_QUERY_KEY,
  BULK_EMAILS_AFFILIATES_LIST_URL,
  BULK_EMAILS_PERMISSIONS,
} from '../constants';

export default function useBulkEmailsAffiliatesQuery(
  payload: Ref<IBulkEmailAffiliatesBasePayload>,
  checkedIds: Ref<number[]>,
  enabled: Ref<boolean>,
): IContextQueryResult<
    IBulkEmailAffiliatesResponse,
    Error,
    IBulkEmailAffiliate[]
  > {
  const { fetchPost } = useRestClient();

  return useContextQuery<
    IBulkEmailAffiliatesResponse,
    Error,
    IBulkEmailAffiliate[]
  >({
    queryKey: [BULK_EMAILS_AFFILIATES_LIST_QUERY_KEY, payload],
    queryFn: ({ signal }) => fetchPost<IBulkEmailAffiliatesResponse>(
      BULK_EMAILS_AFFILIATES_LIST_URL,
      {
        filters: {
          ...payload.value,
          checked_ids: checkedIds.value,
        },
      },
      {
        signal,
        permission: BULK_EMAILS_PERMISSIONS.SHOW,
      },
    ),
    select: (data) => data.affiliates,
    enabled,
  });
}
